import type {
  BuilderAgentRequest,
  BuilderChatHistoryResponse,
} from "@/lib/api/databook";

export function activeBuilderAgentRequest(
  askDillyHistory: BuilderChatHistoryResponse | undefined,
): BuilderAgentRequest | null {
  if (askDillyHistory?.request?.status === "active") {
    return askDillyHistory.request;
  }
  return null;
}

export function builderAgentPollingInterval(
  request: BuilderAgentRequest | undefined,
): number | false {
  return request?.status === "active" ? 2_000 : false;
}
